export default {"src":"/_next/static/media/bal.973a4758.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};